import { AccessGuids, ConfigSystemParams } from '../../consts';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { ComponentAccessUserService } from '../../services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from '../../services/utelize/system/config-system/config-system-service';
import { EspReports } from '../../enums';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FinancialReportDataDTO } from 'src/app/core/models/system/financial/financialreportdata.dto';
import { FinancialService } from '../../services/utelize/system/financial/financial-service';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-dropdown-financial-reports',
  templateUrl: './dropdown-financial-reports.component.html',
  styleUrls: ['./dropdown-financial-reports.component.scss']
})

export class DropdownFinancialReportsComponent implements AfterViewInit, OnInit {

  @Input() initialReportId: number  | undefined;
  
  @Output() selectOnChangeEvent: EventEmitter<number> = new EventEmitter<number>();

  get auditSummaryAllowed() { return this.componentAccessUserService.hasAccessGuid(AccessGuids.ReportAuditSummary,         true); }
  get costSummaryAllowed () { return this.componentAccessUserService.hasAccessGuid(AccessGuids.ReportFinancialCostSummary, true); }
  
  get resellerLevelReports() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridFinancialReportsResellerLevelReporting, false ); }

  private companyIsReseller: boolean=false;
  private reportsIdData!   : FinancialReportDataDTO[];

  public addOrEditForm!: UntypedFormGroup;

  constructor(
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private financialService          : FinancialService,
    private exceptionsService         : ExceptionsService,
    private formBuilder               : FormBuilder
  ) { }

  ngOnInit(): void {
    try {
      this.getDropdownData();

      this.companyIsReseller=false;

      let financialReportId=this.initialReportId==undefined ? 0 : this.initialReportId;

      this.addOrEditForm = this.formBuilder.group({
        reportID: [financialReportId, []]
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  ngAfterViewInit(){
    try {
      this.selectOnChange(undefined);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getDropdownDataObjectArray() {
    try {
      return this.reportsIdData;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
  
  private getDropdownData() {
    try {
      let dataSource: Observable<FinancialReportDataDTO[]>;

      this.resellerLevelReports && this.companyIsReseller
      ? dataSource=this.financialService.getFinancialReportsForReseller()
      : dataSource=this.financialService.getFinancialReports();

      dataSource
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.reportsIdData=(data as FinancialReportDataDTO[])
                             ?.filter(x => x?.id != EspReports.AuditSummary         || this.auditSummaryAllowed)
                             ?.filter(x => x?.id != EspReports.CostSummary          || this.costSummaryAllowed)
                             ?.filter(x => x?.id != EspReports.CostSummaryByCompany || this.costSummaryAllowed);
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public selectOnChange(event: Event | undefined) {
    try {
      let financialReportsID=this.addOrEditForm.controls["reportID"].value;

      if (isNaN(financialReportsID) || financialReportsID=="") {
        financialReportsID=-1;
      }

      this.selectOnChangeEvent.emit(financialReportsID);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }

  public refresh(companyIsReseller: boolean) {
    try {
      this.companyIsReseller=companyIsReseller;

      this.getDropdownData();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
}
